import _ from "lodash";

//         "event": {
//             "selectedTeamId": "11",
//             "competitionId": "1",
//             "competitionName": "Bundesliga",
//             "type": "match",
//             "homeTeamId": "11",
//             "awayTeamId": "20",
//             "side": "home",
//             "eventId": "1000",
//             "dateObj": "202130203023"
//         },
export const getEventFromMatchday = (matchday) => {
  const event = {
    selectedTeamId: matchday.teamId,
    competitionId: matchday.competitionId,
    competitionName: matchday.competitionName,
    type: "match",
    // Optional: an Opta matchday always carries both contestants, so this is
    // identical for every existing caller. A manual matchday may legitimately
    // not have its teams picked yet, and this mapper is reached from half a
    // dozen save paths -- throwing here would lose the save rather than produce
    // a template with empty teams.
    homeTeamId: matchday.home?.id,
    awayTeamId: matchday.away?.id,
    eventId: matchday.eventId,
    date: matchday.date,
    time: matchday.time,
    start_date: matchday.start_date,
    stage: matchday?.stage,
    home: matchday?.home,
    away: matchday?.away,
    ...matchday,
  };

  let side = "home";

  if (event.awayTeamId == event.selectedTeamId) {
    side = "away";
  }

  _.set(event, "side", side);

  return event;
};

/**
 * A matchday the user named by hand, for a competition Opta has no data for.
 *
 * Unlike the Opta mapper it derives nothing: there are no contestants, so there
 * is no `home.id`/`away.id` to read and no `side` to work out. Reusing
 * `getEventFromMatchday` here would throw on `matchday.home.id` before it got
 * anywhere. The matchday already carries the only things that matter -- its own
 * `eventId`, the competition, and the artwork variant -- so it passes straight
 * through.
 */
export const getEventFromMatchdayManual = (matchday) => {
  return {
    ...matchday,
    type: "match",
  };
};

export const getEventFromMatchdayHeimspiel = (matchday) => {
  const event = {
    ...matchday,
    teamId: matchday?.country.id,
  };

  delete event?.eventId
  return event;
};
